/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import MuiButton from '@material-ui/core/Button';
import clsx from 'clsx';

function Button({ className, ...props }) {
  return (
    <MuiButton
      className={clsx({
        [className]: true,
      })}
      {...props}
    />
  );
}

Button.defaultProps = {
  color: 'primary',
  variant: 'contained',
  disabled: false,
};

export default Button;
